import { Trans as _Trans } from "../lib/i18n/Trans";
import * as React from "react";
import { Suspense } from "react";
import { ChunkLoadError } from "./safeLazy";
/**
 * Error boundary that only catches ChunkLoadError (thrown by safeLazy).
 * All other errors are re-thrown to be handled by a parent error boundary.
 */
class ChunkLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasChunkError: false
    };
  }
  static getDerivedStateFromError(error) {
    if (error instanceof ChunkLoadError) {
      return {
        hasChunkError: true
      };
    }
    return null;
  }
  componentDidCatch(error) {
    if (!(error instanceof ChunkLoadError)) {
      throw error;
    }
  }
  render() {
    if (this.state.hasChunkError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

/**
 * Combines Suspense + ErrorBoundary for lazy-loaded components.
 *
 * On loading: renders the fallback.
 * On ChunkLoadError (e.g. chunk load failure while navigation is locked):
 *   renders the same fallback with a "failed to load" message overlay.
 * Other errors are not caught and propagate to parent error boundaries.
 */
export function SafeSuspense({
  children,
  fallback
}) {
  return /*#__PURE__*/React.createElement(ChunkLoadErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, fallback, /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-muted-foreground"
    }, /*#__PURE__*/React.createElement(_Trans,
    /** i18n */
    {
      id: "WfEHYk",
      message: "Failed to load. Please reload the page."
    }))))
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: fallback
  }, children));
}
//# sourceMappingURL=SafeSuspense.js.map